import React, { useEffect, useRef, useState } from "react"
import { ArrowUp } from "lucide-react"

/**
 * Reading progress bar at the top of the page plus a "back to top" button.
 * Progress is written directly to the DOM to avoid re-rendering on every scroll frame.
 */
export const ScrollExtras: React.FC = () => {
    const barRef = useRef<HTMLDivElement>(null)
    const [showTop, setShowTop] = useState(false)

    useEffect(() => {
        let ticking = false

        const update = () => {
            const doc = document.documentElement
            const max = doc.scrollHeight - doc.clientHeight
            const ratio = max > 0 ? Math.min(1, window.scrollY / max) : 0
            if (barRef.current) {
                barRef.current.style.transform = `scaleX(${ratio})`
            }
            setShowTop(window.scrollY > 600)
            ticking = false
        }

        const onScroll = () => {
            if (!ticking) {
                ticking = true
                window.requestAnimationFrame(update)
            }
        }

        update()
        window.addEventListener("scroll", onScroll, { passive: true })
        window.addEventListener("resize", onScroll)
        return () => {
            window.removeEventListener("scroll", onScroll)
            window.removeEventListener("resize", onScroll)
        }
    }, [])

    const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" })

    return (
        <>
            <div className="lp-progress" aria-hidden="true">
                <div className="lp-progress__bar" ref={barRef} />
            </div>
            <button
                type="button"
                className={`lp-top${showTop ? " is-visible" : ""}`}
                onClick={scrollTop}
                aria-label="Zpět nahoru"
                title="Zpět nahoru"
            >
                <ArrowUp size={20} />
            </button>
        </>
    )
}
